module.exports = __webpack_public_path__ + "img/usdc.72479539.png";